import { css } from 'styled-components';

const CalendarEventForm = {
  wrapper: css`
    width: 100%;
    background-color: #fff;
  `,
  row: css`
    display: flex;
    width: 100%;
  `,
  formHeader: css`
    background-color: #DDF2FF;
    width: 100%;
    color: #278ECD;
    text-align: center;
    padding: 11px;
    text-transform: uppercase;
    font-weight: 500;
    display: none;
    letter-spacing: 2px;
    ${({ theme }) => `
      ${theme.breakPoints.tablet} {
        display: block;
      }
    `}
  `,
  formHeaderMobile: css`
    width: 100%;
    font-weight: 600;
    ${({ theme }) => `
      ${theme.breakPoints.tablet} {
        display: none;
      }
    `}
    button.fhm__back {
      background-color: transparent;
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      position: absolute;
      left: 16px;
      top: 16px;
    }

    button.fhm__close {
      background-color: transparent;
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      position: absolute;
      right: 16px;
      top: 16px;
    }

    svg {
      width: 20px !important;
      height: 20px !important;
      fill: #fff;
      g , use {
        fill: #fff;
      }
    }
  `,
  typeSelectorSection: css`
    background-color: #fff;
    padding: 20px;
    display: none;
    ${({ theme }) => `
      ${theme.breakPoints.tablet} {
        display: block;
        min-width: 300px;
      }
    `}
  `,
  eventFormSection: css`
    width: 100%;
    padding: 20px;
    padding-bottom: 30px;
    p {
      margin: 0;
    }
  `,
  eventTypeSelectMobile: css`
    ${({ theme }) => `
      max-width: 420px;
      width: 100%;
      margin: 0 auto;
      ${theme.breakPoints.tablet} {
        display: none;
      }
    `}
  `,
  fontBuilderContainer: css`
    ${({ theme }) => `
      ${theme.breakPoints.tablet} {
        display: block;
      }
    `}
  `,
  navigationHeader: css`
    background-color: #f8f8f8;
    align-items: center;
    padding: 0 10px;
    display: none;
    svg {
      height: 20px !important;
      margin: 10px;
      cursor: pointer;
    }
    ${({ theme }) => `
      ${theme.breakPoints.tablet} {
        display: flex;
        padding: 1rem 0;
      }
    `}
  `,
  navigationHeaderText: css`
    color: #657480;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
  `,
};

export default CalendarEventForm;
